import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import type {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import type {ApiSingleResponseWithData} from '../../../interfaces/api-response.interface';

const baseUrl = environment.baseUrl;

/** Action d'abonnement proposée au citoyen (contrat Odoo / Clésame v1). */
export type SubscriptionNextAction = 'manage_subscription' | 'contact_support';

/** Abonnement du citoyen courant (GET /me/abonnement), réduit à ce que l'application affiche. */
export interface MonAbonnement {
  nextAction: SubscriptionNextAction;
  /** Lien portail Odoo (validé côté serveur : HTTPS, hôte autorisé), présent seulement pour « gérer ». */
  managementUrl: string | null;
  subscriptionFound: boolean;
  reference: string | null;
  offerCode: string | null;
  status: string | null;
  /** Odoo momentanément indisponible : afficher l'action support. */
  indisponible: boolean;
}

/**
 * Abonnement du citoyen authentifié. Le lien retourné contient un jeton d'accès au portail Odoo :
 * il n'est jamais stocké ni journalisé côté front (réponse non cachable côté serveur).
 */
@Injectable({providedIn: 'root'})
export class MonAbonnementService {
  private readonly http = inject(HttpClient);

  getMonAbonnement(): Observable<ApiSingleResponseWithData<MonAbonnement>> {
    return this.http.get<ApiSingleResponseWithData<MonAbonnement>>(`${baseUrl}me/abonnement`);
  }
}
